import { render, staticRenderFns } from "./CommonCard.vue?vue&type=template&id=91971080&scoped=true"
import script from "./CommonCard.vue?vue&type=script&lang=js"
export * from "./CommonCard.vue?vue&type=script&lang=js"
import style0 from "./CommonCard.vue?vue&type=style&index=0&id=91971080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91971080",
  null
  
)

export default component.exports